import React, {useEffect} from 'react';
import PegawaiContent from "../contents/PegawaiContent";
import Header from "../components/Header";
import CustomeNavbar from "../components/CustomeNavbar";
import ToTop from "../components/ToTop";
import Footer from "../components/Footer";

const Pegawai = () => {
    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth',
        });
    };

    useEffect(() => {
        scrollToTop();
    }, []);
    return (
        <div>
            <Header />
            <CustomeNavbar />
            <PegawaiContent />
            <ToTop />
            <Footer />
        </div>
    );
};

export default Pegawai;